import { Modal } from "react-bootstrap";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { ArchiveFile } from "Services/PGXLis/ResultUpload";
import useLang from "Shared/hooks/useLanguage";
// import ResultFileUploadGrid from "./ResultFileUploadGrid";

function ArchiveModal({
  show,
  setShow,
  selectedRecord,
  loadGridData,
  setSelectedBox,
}: {
  setShow: any;
  show: boolean;
  selectedRecord: number[];
  loadGridData: (loader: boolean, reset: boolean, sortingState?: any) => void;
  setSelectedBox: any;
}) {
  const { t } = useLang();

  const ModalhandleClose = () => setShow(false);

  const archiveMutation = useMutation({
    mutationFn: async (ids: number[]) => {
      const res = await ArchiveFile(ids);
      return res;
    },

    onSuccess: (res) => {
      if (res.status === 200) {
        setSelectedBox((prevState: any) => ({
          ...prevState,
          id: [],
        }));
        loadGridData(true, true);
        ModalhandleClose();
        setShow(false);
        toast.success(t(res?.data?.message));
      }
    },

    onError: (error: any) => {
      console.error(error, "bulk request failure");
      toast.error("Archive failed");
    },
  });

  return (
    <Modal
      show={show}
      onHide={ModalhandleClose}
      backdrop="static"
      keyboard={false}
      className="d-flex align-item-center"
      dialogClassName="no-shadow-modal-content"
    >
      <Modal.Header closeButton className="py-4 bg-light-primary">
        <Modal.Title className="h5">{t("Archive Record")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("Are you sure you want to archive this record ?")}
      </Modal.Body>
      <Modal.Footer className="py-2">
        <button
          id="IDResultFileModalArchiveCancel"
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={ModalhandleClose}
        >
          {t("Cancel")}
        </button>
        <button
          id="IDResultFileModalArchiveSave"
          type="button"
          className="btn btn-sm btn-danger"
          onClick={() => archiveMutation.mutate(selectedRecord)}
        >
          {t("Archive")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ArchiveModal;
